function TriviaChampion() {
  return (
    <section className="w-full py-20 px-6" style={{ backgroundColor: '#F7941D' }}>
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-6">
        <h2 className="font-boxen text-dark text-xl sm:text-2xl md:text-3xl leading-tight text-center md:text-left">
          BE A TRIVIA BOWL CHAMPION
        </h2>

        <p className="font-poppins text-dark text-sm sm:text-base leading-relaxed text-left">
          Create a team. Then rack up points by frequenting a Trivia Nights Live
          location on trivia night and be eligible to compete in one of 2 of our
          yearly bowl events. We host the Trivia Bowl in the winter and then the
          Summer Bowl. You can follow your team&apos;s progress on TrivTrak.
          Prizes, medals, trophy and bragging rights go to the champions.
          Check the leaderboard at trivtrak.com.
        </p>

        <a
          href="https://trivtrak.com"
          target="_blank"
          rel="noreferrer"
          className="font-poppins font-bold text-dark text-sm sm:text-base tracking-widest uppercase border-2 border-dark px-6 py-2 rounded hover:bg-dark hover:text-white transition-colors duration-200"
        >
          trivtrak.com
        </a>
      </div>
    </section>
  );
}

export default TriviaChampion;
